/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Component
import { PriceLabel } from './PriceLabel';
import { textPercentageOff } from '../helpers/priceTypeConstants';

// Styles
import styles from './styles.scss';

type NetProps = {|
    currency: string,
    percentageOff: ?number,
    price: number,
    quantityDisplay?: string,
    showPriceVariability: boolean,
    isTestVariant?: boolean,
|};

export function Net({
    percentageOff,
    price,
    quantityDisplay,
    currency,
    showPriceVariability,
    isTestVariant,
}: NetProps) {
    const label = (
        <FormattedMessage id="dc.searchProductTile.netPrice" defaultMessage="Net Price" />
    );

    return (
        <React.Fragment>
            <PriceLabel
                price={price}
                label={label}
                quantityDisplay={quantityDisplay}
                currency={currency}
                showPriceVariability={showPriceVariability}
            />
            {percentageOff ? (
                <div
                    className={`${styles.percentageOff} ${styles.net} ${
                        isTestVariant ? styles.testVariant : ''
                    }`}
                    data-tn="discount-amount"
                >
                    {textPercentageOff(percentageOff)}
                </div>
            ) : null}
        </React.Fragment>
    );
}

Net.defaultProps = {
    percentageOff: null,
    showPriceVariability: false,
};
